var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-md-date-range-picker',{attrs:{"showActivatorLabel":false,"locale":_vm.locale,"start-date":_vm.dates[0],"end-date":_vm.dates[1],"max-date":_vm.today,"opens":"right"},on:{"change":_vm.handleChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }